<template>
  <div class="text-xs-left">
    <div class="v-label v-label--active theme--light">Statuses </div>

    <v-chip :color="color(item)" v-for="item in allStatus" :key="item.id"
        @click="statusChanged(item)">
        <v-avatar v-show="statusSelected(item)">
            <v-icon>check_circle_outline</v-icon>
        </v-avatar>
        <v-avatar v-show="!statusSelected(item)">
            <v-icon>radio_button_unchecked</v-icon>
        </v-avatar>
        {{item.name}}
    </v-chip>

    <!-- {{selectedStatus}} -->
  </div>
</template>
<script>
export default {
    props: ['allStatus', 'selectedStatus'],
    data() {
        return {}
    },
    methods: {
        statusSelected(status) {
            return !this.selectedStatus? false :
                this.selectedStatus.findIndex(item=>item == status.id) >= 0
        },
        color(item) {
            return this.statusSelected(item)? 'green' : ''
        },
        statusChanged(status) {
            let statusClone = [...this.selectedStatus]
            if(this.statusSelected(status)) {
                //remove
                statusClone = statusClone.filter(item => item != status.id)
            }
            else {
                //add
                statusClone = [...statusClone, status.id]

            }

            this.$emit('statusChanged', statusClone)
        }
    },

}
</script>
